import { sendCriteoEvent } from '@ma-js-common/criteo-helpers';

import { contactMapThorEvent, getLeadId, referenceMessage } from './contact';
import { hasTouchEvents } from './device';
import { addClass, hasClass, removeClass } from './domHelpers';
import { bindAjaxForm } from './form.es6';
import MAEvent from './ma-event';
import Navigation from './navigation';
import { bindForm } from './tagging';
import { getThorViewEventProps, thorFormatPlaceName, thorPushEvent } from './thor';
import { addURLParams } from './utils';
import WA from './wa';

export function initializeTooltip() {
    const tooltips = document.querySelectorAll('[data-tooltip]');

    for (let i = 0; i < tooltips.length; i++) {
        const tooltip = tooltips[i];
        const tooltipPanel = tooltip.querySelector('[data-tooltip-panel]');
        const inactiveClass = 'tooltip__panel--inactive';

        if (hasClass(tooltipPanel, inactiveClass)) {
            if (!hasTouchEvents()) {
                tooltip.addEventListener('mouseover', () => {
                    removeClass(tooltipPanel, inactiveClass);
                });

                tooltip.addEventListener('mouseout', () => {
                    addClass(tooltipPanel, inactiveClass);
                });
            } else {
                tooltip.addEventListener('touchstart', event => {
                    if (hasClass(tooltipPanel, inactiveClass)) {
                        event.stopPropagation();
                        removeClass(tooltipPanel, inactiveClass);

                        $('body').one('touchstart', () => {
                            addClass(tooltipPanel, inactiveClass);
                        });
                    } else {
                        addClass(tooltipPanel, inactiveClass);
                    }
                });
            }
        }
    }
}

/**
 * Open a popin and call a callback if provided
 * @param {String} src URL or taget ID to fill content
 * @param {String} type Default `ajax`. See magnificPopup doc
 * @param {Function} callback
 */
export function initializePopin(src, callback, type = 'ajax') {
    $.magnificPopup.open(
        {
            items: {
                type,
                src,
            },
            fixedContentPos: 'fixed',
            callbacks: {
                ajaxContentAdded() {
                    // Ajax content is loaded and appended to DOM
                    Navigation.disablePageScroll();

                    this.content.find('[data-close]').on('click', e => {
                        e.preventDefault();
                        $.magnificPopup.instance.close();
                    });

                    if (typeof callback === 'function') {
                        callback(this.content);
                    }
                },
                close() {
                    Navigation.enablePageScroll();
                },
            },
        },
        0,
    );
}

export function initializeRealtorMessagePopin(category, action, label, source) {
    // Click on the realtor request button on realtors list
    $('[data-realtor-request-from-list], [data-realtor-request-from-list-mobile]').on(
        'click',
        function showRealtorMessagePopin(e) {
            e.preventDefault();
            const $this = $(this);

            const realtorId = $(this).attr('data-realtor-id');
            const realtorType = $(this).attr('data-realtor-type');
            sendCriteoEvent({
                event: 'viewBasket',
                item: [{ id: realtorId, quantity: '1', price: '1' }],
                atype: realtorType,
            });

            contactMapThorEvent({
                eventName: 'form_opened',
                realtorId,
                leadId: getLeadId(realtorId),
            });

            initializePopin($this.data('href'), content => {
                const $form = content.find('form');
                bindAjaxForm($form, content.find('[data-message-success]'), true, null);

                $form.one(MAEvent.formSubmitAttempt, () => {
                    const project = $form.find('#project')[0].value;
                    contactMapThorEvent({
                        eventName: 'form_submit',
                        project,
                        realtorId: $form.data('realtor-id'),
                        leadId: getLeadId($form.data('realtor-id')),
                    });
                });

                $form.one(MAEvent.formSubmitSuccess, () => {
                    const project = $form.find('#project')[0].value;
                    contactMapThorEvent({
                        eventName: 'form_confirm',
                        project,
                        realtorId: $form.data('realtor-id'),
                        leadId: getLeadId($form.data('realtor-id')),
                    });
                });

                $form.on(MAEvent.formSubmitSuccess, () => {
                    $('[data-popin]').addClass('popin--estima-realtor-contact-success');
                    $('[data-popin-title-container]').addClass('hide');
                    $('[data-popin-body]').addClass('popin__body--estima-realtor-contact-success');
                });

                $('#optin').on('change', function onRealtorMessageOptinChange() {
                    if (this.checked) {
                        $('input[data-intent]').val(
                            'REALTOR_MESSAGE_INTENTS.DIRECT_EVALUATION_REQUEST',
                        );
                    } else {
                        $('input[data-intent]').val('REALTOR_MESSAGE_INTENTS.REALTOR_CONTACT');
                    }
                });

                bindForm(
                    $form,
                    {
                        category,
                        actionPrefix: action,
                        label,
                    },
                    {
                        key: 'form_success',
                        name: 'realtor_contact',
                        data: `source=${WA.updateSourceWhenRetargeting(
                            source,
                        )}|realtor_id=${$this.data('realtor-id')}`,
                    },
                    null,
                    null,
                    {
                        id: realtorId,
                        atype: realtorType,
                    },
                );
            });
            if (
                window.location.pathname.includes('/professionnel-immobilier/') ||
                window.location.pathname.includes('/mandataire-immobilier/') ||
                window.location.pathname.includes('/agence-immobiliere/')
            ) {
                const { realtorSearchPlace } = MA.Context;
                const placeName =
                    realtorSearchPlace.geotype_label === 'subregion'
                        ? { av_province: realtorSearchPlace.zip }
                        : {
                              av_city: thorFormatPlaceName(realtorSearchPlace.name_base),
                              av_zip_code: realtorSearchPlace.zip,
                              av_province: realtorSearchPlace.zip.slice(0, 2),
                          };
                thorPushEvent('page_view', {
                    ...getThorViewEventProps('find_pro', `${realtorType}_contact_popin`),
                    av_items: [{ id: realtorId }],
                    ...placeName,
                });
            }
        },
    );
}

export function initializeBestRealtorsFormPopin(callback) {
    // Click on the realtor request button on realtors list
    $('[data-open-best-realtors-form-popin]').on('click', function showBestRealtorsFormPopin(e) {
        e.preventDefault();
        const $this = $(this);

        initializePopin($this.data('href'), () => {
            callback();
        });
    });
}

/**
 * Initialize contact form popin that opens when clicking
 * on an element with selectorAttribute (e.g: data-reference-message)
 * @param selectorAttribute {String}
 * @param useHtmlGaLabel {Boolean}
 * @param $container {jQuery} Container used for dom selection
 */
export function initializePastSalePopin(selectorAttribute, useHtmlGaLabel) {
    function handler(e) {
        const $this = $(this);
        // If user click on classic link inside the div
        if (e.target.href && e.target.href !== '#' && !e.target.hasAttribute(selectorAttribute)) {
            return;
        }
        e.preventDefault();

        const src = addURLParams($this.data('url'), {
            ga_category: MA.Context.gaCategory,
            ga_label_prefix: `${MA.Context.gaLabelPrefix}:past_sale_popin`,
            wa_name_prefix: `${MA.Context.gaLabelPrefix}:past_sale_popin`,
            wa_source: MA.Context.waSource || MA.Context.gaLabelPrefix,
            wa_source_deprecated: `${MA.Context.mapGaLabelPrefix}:past_sale`,
            ga_tag: 'from:prices:past_sales_list',
            source: 'REALTOR_MESSAGE_SOURCES.PRICES',
        });

        const GaLabel = useHtmlGaLabel
            ? this.getAttribute('data-ua-event-label')
            : `from:${MA.Context.gaLabelPrefix}:past_sales_list`;

        $.magnificPopup.open(
            {
                type: 'ajax',
                closeBtnInside: false,
                fixedContentPos: 'fixed',
                items: {
                    src,
                },
                callbacks: {
                    ajaxContentAdded() {
                        // Ajax content is loaded and appended to DOM
                        Navigation.disablePageScroll();
                        const $form = $(this.content).find('[data-message-form]');

                        referenceMessage(
                            this.content,
                            {
                                category: MA.Context.gaCategory,
                                actionPrefix: 'past_sale:popin',
                                label: GaLabel,
                            },
                            {
                                key: 'form_success',
                                name: 'realtor_contact',
                                data: `source=${WA.updateSourceWhenRetargeting(
                                    MA.Context.waSource || MA.Context.gaLabelPrefix,
                                )}:past_sales_list|realtor_id=${$form.data(
                                    'realtor-id',
                                )}|reference_id=${$form.data('reference-id')}`,
                            },
                            {
                                key: 'page_view:past_sale',
                                name: `${MA.Context.gaLabelPrefix}:past_sales_list`,
                                data: `source=${MA.Context.waSource ||
                                    MA.Context.gaLabelPrefix}|realtor_id=${$form.data(
                                    'realtor-id',
                                )}|reference_id=${$form.data('reference-id')}`,
                            },
                        );
                    },
                    close() {
                        Navigation.enablePageScroll();
                    },
                },
            },
            0,
        );
    }

    $(`[${selectorAttribute}]`).on('click', handler);
}

export function openModal(popinNode) {
    $.magnificPopup.open({
        fixedContentPos: 'fixed',
        modal: true,
        items: {
            type: 'inline',
            src: popinNode,
        },
    });
}
